import { all, fork, put, takeEvery } from 'redux-saga/effects';

import { fetchPage } from 'modules/app/sagas/resolveAll';
import { simpleRequestsLoader } from 'modules/app/utils';
import type { ApiError } from 'modules/global/generic.types';
import * as actions from 'modules/guidelines/actions';
import * as actionTypes from 'modules/guidelines/actionTypes';

import dashboardSaga from './dashboard';
import detailsSaga from './details';
import requestsConfig from './requestsConfig';
import guidelinesSockets from './sockets.saga';
import type { PaginatedLatestGuideline } from '../types';
import type { FetchGuidelinesAction } from '../types/actions';

/**
 * Guideline list fetch. The dashboard slices discriminate via `meta.source`, which is
 * passed through to the success/failure actions. Paginates through every page via
 * `fetchPage`, so it stays a manual saga. Runs globally because it is also triggered
 * outside the dashboard (dealer-config sales preload, guideline selects).
 * `takeEvery` is required: the group and dealer lists are fetched back-to-back with
 * the same action type — `takeLatest` would cancel the first one.
 */
function* fetchGuidelines({ payload, meta }: FetchGuidelinesAction) {
  try {
    const response = yield* fetchPage<PaginatedLatestGuideline>(payload.request);
    yield put(actions.fetchGuidelinesSuccess(response, meta));
  } catch (error) {
    yield put(actions.fetchGuidelinesFailure(error as ApiError, meta));
  }
}

export default function* guidelineSagas() {
  yield all([
    ...simpleRequestsLoader(requestsConfig),
    takeEvery(actionTypes.FETCH_GUIDELINES, fetchGuidelines),
    fork(dashboardSaga),
    fork(detailsSaga),
    fork(guidelinesSockets),
  ]);
}
